exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vfc-time-picker-container[data-v-bac60cee]{min-width:250px}.vfc-time-picker-container .vfc-modal-time-line>span>span[data-v-bac60cee]:not(:nth-child(2)):not(.vfc-active):hover{cursor:pointer}.vfc-time-picker-container .titles[data-v-bac60cee]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:10px 0}.vfc-time-picker-container .titles>div[data-v-bac60cee]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center;color:#66b3cc;word-break:break-all;font-size:25px}.vfc-time-picker-container .vfc-time-picker[data-v-bac60cee]{padding-bottom:20px}", ""]);

// exports
